import { ConfigCreateHTHTerritories } from './subcomponents/ConfigCreateHTHTerritories';
import { ConfigRemoveCongregationModal } from './subcomponents/ConfigRemoveCongregationModal';
import { ConfigSendInvitationNewCongregation } from './subcomponents/ConfigSendInvitationNewCongregation';
import { configServices } from 'src/services';
import { ConfigSetCongregationArea } from './subcomponents/ConfigSetCongregationArea';
import { ConfigSetCongregationName } from './subcomponents/ConfigSetCongregationName';
import { H2 } from 'src/components/_commons';
import { hideLoadingModalReducer, setAlertResponse, showLoadingModalReducer } from 'src/store';
import { useDispatch } from 'react-redux';
import { useGetConfig, useGetCurrentUser } from 'src/custom-hooks';
import { useState } from 'react';

const btnClasses = 'btn btn-general-blue btn-size12 d-block mx-auto mt-2 mb-0';

const btnStyles = { width: '400px', minHeight: '80px' };

export const AdminsConfig = () => {
    const [showCreateHthTerritories, setShowCreateHthTerritories] = useState(false);
    const [showInvitationForNewCongregation, setShowInvitationForNewCongregation] = useState(false);
    const [showRemoveCongregation, setShowRemoveCongregation] = useState(false);
    const [showSetCongregationArea, setShowSetCongregationArea] = useState(false);
    const [showSetCongregationName, setShowSetCongregationName] = useState(false);
    const config = useGetConfig();
    const dispatch = useDispatch();
    const user = useGetCurrentUser();

    const downloadBackupHandler = async (all: boolean) => {
        dispatch(showLoadingModalReducer());
        const response = await configServices.DownloadDbBackup(all);
        dispatch(hideLoadingModalReducer());
        if (!response.success) {
            dispatch(setAlertResponse({ response }));
        }
    }

    return (
        <>
        <H2 title={'CONFIGURACIÓN'} />
        {!showCreateHthTerritories && !showInvitationForNewCongregation && !showSetCongregationArea && !showSetCongregationName &&
            <>
            <button className={btnClasses}
                style={btnStyles}
                onClick={() => setShowSetCongregationName(true)}
            >
                {!!config.name ? "Cambiar el nombre de la Congregación" : "Cargar el nombre de la Congregación"}
            </button>
            <button className={btnClasses}
                style={btnStyles}
                onClick={() => setShowSetCongregationArea(true)}
            >
                Editar la Localidad del Territorio
            </button>
            {!!config.name && !config.numberOfTerritories &&
                <button className={btnClasses}
                    style={btnStyles}
                    onClick={() => setShowCreateHthTerritories(true)}
                >
                    Crear Territorios de Casa en Casa
                </button>
            }
            {/* <h5 className={isDarkMode ? 'text-white' : ''}> Duración de accesos: 3 meses </h5> */}
            <button className={btnClasses}
                style={btnStyles}
                onClick={() => downloadBackupHandler(false)}
            >
                Generar y descargar una copia de seguridad de la base de datos (no incluye archivos del Tablero)
            </button>
            {user.isSuperAdmin &&
                <>
                {showInvitationForNewCongregation &&
                    <ConfigSendInvitationNewCongregation
                        setShowInvitationForNewCongregation={setShowInvitationForNewCongregation}
                    />
                }
                {showRemoveCongregation &&
                    <ConfigRemoveCongregationModal
                        closeModal={() => setShowRemoveCongregation(false)}
                    />
                }
                <H2 title={'FUNCIONES DE SUPER ADMINISTRADOR'} />
                <button className={btnClasses}
                    style={btnStyles}
                    onClick={() => downloadBackupHandler(true)}
                >
                    Generar y descargar una copia de seguridad de la base de datos de todas las Congregaciones (no incluye archivos del Tablero)
                </button>
                <button className={btnClasses}
                    style={btnStyles}
                    onClick={() => setShowInvitationForNewCongregation(true)}
                >
                    Enviar invitación para Congregación nueva
                </button>
                <button className={btnClasses}
                    style={btnStyles}
                    onClick={() => setShowRemoveCongregation(true)}
                >
                    Eliminar una Congregación
                </button>
                </>
            }
            </>
        }
        {showCreateHthTerritories &&
            <ConfigCreateHTHTerritories
                setShowCreateHthTerritories={setShowCreateHthTerritories}
            />
        }
        {showSetCongregationArea &&
            <ConfigSetCongregationArea
                setShowSetCongregationArea={setShowSetCongregationArea}
            />
        }
        {showSetCongregationName &&
            <ConfigSetCongregationName
                setShowSetCongregationName={setShowSetCongregationName}
            />
        }
        </>
    );
}
